export { SuiSearchModule, SearchService } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/search/public.js
// module id = 1118
// module chunks = 0